/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import { USER_ROLE } from "../../../core/constants/common";
import DCEListContainer from "./AssessmentList/DCEListContainer";
import FormSubmission from "./FormSubmission/FormSubmission";
import useHasPermission from "../../../core/hooks/useHasPermission";

function Forms() {
  const [isFormSubmission, setIsFormSubmission] = useState("");
  var data = JSON.parse(localStorage.getItem("authority"));
  const { hasDataCollectionViewPermission } = useHasPermission();
  useEffect(() => {
    if (data.roles.includes("SUPER_ADMIN")) {
      setIsFormSubmission(false);
    } else if (hasDataCollectionViewPermission()) {
      setIsFormSubmission(false);
    } else if (data.roles.includes("SUPPLIER_ADMIN")) {
      setIsFormSubmission(true);
    }



    // if (data.roles.includes("SUPER_ADMIN")) {
    //   setIsFormSubmission(false);
    // } else if (PermissionUtils.hasCompanyAdminPermission(data.roles)) {
    //   setIsFormSubmission(false);
    // } else if (data.roles.includes("SUPPLIER_ADMIN")) {
    //   setIsFormSubmission(true);
    // }
  },[data.roles]);
  return (
    <>
      {
        isFormSubmission !== "" &&
        // (isFormSubmission ? <FormSubmission /> : <FormSharing />)
        (isFormSubmission ? <FormSubmission /> : <DCEListContainer />)
      }
    </>
  );
}
Forms.propTypes = {};

Forms.defaultProps = {};

export default Forms;
